import { Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAppSelector } from '@/store/hook'
import { selectAuthLoading, selectIsAuthenticated, selectCurrentUser } from '@/store/slices/authSlice'
import { USER_ROLES } from '../layout/navigation'


const ProtectedRoute = ({ 
  children, 
  requireSuperAdmin = false, // Keep backward compatibility
  allowedRoles = [], // New role-based approach
  redirectTo = '/unauthorized' 
}) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const isLoading = useAppSelector(selectAuthLoading)
  const user = useAppSelector(selectCurrentUser)

  // Show loading spinner while auth is loading
  if (isLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress />
      </Box>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Handle legacy requireSuperAdmin prop
  if (requireSuperAdmin) {
    const userRole = user?.role
    const isSuperAdmin = userRole === USER_ROLES.ADMIN // Assuming ADMIN is your super admin role
    
    if (!isSuperAdmin) {
      return <Navigate to={redirectTo} replace />
    }
  }

  // Handle new role-based access control
  if (allowedRoles.length > 0) {
    const userRole = user?.role
    
    const hasRequiredRole = allowedRoles.includes(userRole)
    
    if (!hasRequiredRole) {
      return <Navigate to={redirectTo} replace />
    }
  }

  return children
}

export default ProtectedRoute